(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefit-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBenefitSliders = (root = document) => {
      const sliders = root.querySelectorAll(
        '[data-lc-benefit-slider]'
      );

      sliders.forEach((slider) => {
        if (slider.dataset.lcInitialized === 'true') {
          return;
        }

        const items = Array.from(
          slider.querySelectorAll('[data-lc-benefit-item]')
        );

        if (!items.length) {
          return;
        }

        slider.dataset.lcInitialized = 'true';
        slider.classList.add('is-initialized');

        let currentIndex = 0;
        let timer = null;

        const showItem = (index) => {
          items.forEach((item, itemIndex) => {
            item.classList.toggle(
              'is-active',
              itemIndex === index
            );
          });
        };

        const stopSlider = () => {
          if (timer) {
            window.clearInterval(timer);
            timer = null;
          }
        };

        const startSlider = () => {
          stopSlider();

          if (items.length < 2) {
            return;
          }

          timer = window.setInterval(() => {
            currentIndex = (currentIndex + 1) % items.length;
            showItem(currentIndex);
          }, 4000);
        };

        const mobileQuery = window.matchMedia(
          '(max-width: 767px)'
        );

        const reducedMotionQuery = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        const updateSlider = () => {
          showItem(currentIndex);

          if (
            mobileQuery.matches &&
            !reducedMotionQuery.matches
          ) {
            startSlider();
          } else {
            stopSlider();
          }
        };

        updateSlider();

        if (mobileQuery.addEventListener) {
          mobileQuery.addEventListener('change', updateSlider);
          reducedMotionQuery.addEventListener(
            'change',
            updateSlider
          );
        } else {
          mobileQuery.addListener(updateSlider);
          reducedMotionQuery.addListener(updateSlider);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => {
      initializeBenefitSliders();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initializeBenefitSliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxecosy-bettdeckenberater"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalise = (value) => String(value || '')
      .toLowerCase()
      .replace(/×/g, 'x')
      .replace(/\s+/g, '')
      .replace(/[()]/g, '');

    const escapeHtml = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    const initialise = (root) => {
      if (root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';

      const products = {};
      root.querySelectorAll('[data-lc-db-product]').forEach((script) => {
        try {
          const product = JSON.parse(script.textContent);
          if (product && product.key && product.variants && product.variants.length) products[product.key] = product;
        } catch (error) {
          script.dataset.invalid = 'true';
        }
      });

      const finder = root.querySelector('[data-lc-db-finder]');
      const result = root.querySelector('[data-lc-db-result]');
      const steps = Array.from(root.querySelectorAll('[data-lc-db-step]'));
      const next = root.querySelector('[data-lc-db-next]');
      const back = root.querySelector('[data-lc-db-back]');
      const edit = root.querySelector('[data-lc-db-edit]');
      const usageSelect = root.querySelector('[data-lc-db-select="usage"]');
      const sizeSelect = root.querySelector('[data-lc-db-select="size"]');

      const state = {
        step: 0,
        temperature: 'normal',
        feeling: 'balanced',
        material: 'open',
        usage: 'single',
        size: '135x200',
        priority: 'comfort',
        product: null,
        variant: null
      };
      let autoAdvanceTimer;

      const contexts = [
        'Temperatur im Schlafzimmer',
        'Ihr persönliches Wärmegefühl',
        'Material und Pflege',
        'Größe und Schlafsituation',
        'Ihre gewünschte Komfortstufe'
      ];

      const sizeOptions = {
        single: [
          ['135x200', '135 × 200 cm'],
          ['155x220', '155 × 220 cm']
        ],
        shared: [
          ['200x200', '200 × 200 cm'],
          ['200x220', '200 × 220 cm'],
          ['240x220', '240 × 220 cm']
        ],
        separate: [
          ['135x200', '2 Einzeldecken – je 135 × 200 cm'],
          ['155x220', '2 Einzeldecken – je 155 × 220 cm']
        ]
      };

      const warmthKeys = ['summer', 'light', 'allseason', 'winter', 'extra'];
      const warmthLabels = {
        summer: 'Sommerdecke',
        light: 'Leichte Ganzjahresdecke',
        allseason: 'Ganzjahresdecke',
        winter: 'Winterdecke',
        extra: 'Extra warme Winterdecke'
      };
      const temperatureIndex = { warm: 0, mild: 1, normal: 2, cool: 3, cold: 4 };
      const feelingOffset = { hot: -1, balanced: 0, cold: 1 };
      const feelingLabels = {
        hot: 'Sie schwitzen schnell',
        balanced: 'Ihr Wärmeempfinden ist ausgeglichen',
        cold: 'Sie frieren schnell'
      };
      const materialLabels = {
        down: 'Daune',
        silk: 'Seide und Lyocell',
        camel: 'Kamelhaar',
        vegan: 'PrimaLoft Bio®'
      };

      const renderSizes = () => {
        const options = sizeOptions[state.usage] || sizeOptions.single;
        sizeSelect.innerHTML = options
          .map(([value, label]) => `<option value="${value}">${label}</option>`)
          .join('');
        if (!options.some(([value]) => value === state.size)) state.size = options[0][0];
        sizeSelect.value = state.size;

        const insight = root.querySelector('[data-lc-db-size-insight]');
        if (state.usage === 'separate') {
          insight.textContent = 'Wir empfehlen zwei Einzeldecken. So kann jede Person Material und Wärmegrad unabhängig wählen.';
        } else if (state.usage === 'shared') {
          insight.textContent = '200 × 200 cm ist die kompakte Paardecke; 200 × 220 cm und 240 × 220 cm bieten mehr Länge und Bewegungsfreiheit.';
        } else {
          insight.textContent = '135 × 200 cm ist die klassische Einzelgröße. Ab etwa 1,80 m Körpergröße ist 155 × 220 cm häufig komfortabler.';
        }
      };

      const scrollToActiveStep = () => {
        if (!window.matchMedia('(max-width: 680px)').matches) return;
        const activeStep = steps[state.step];
        if (!activeStep) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.requestAnimationFrame(() => {
          activeStep.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      };

      const renderStep = (reposition = false) => {
        steps.forEach((step, index) => step.classList.toggle('is-active', index === state.step));
        const counter = root.querySelector('[data-lc-db-counter]');
        const context = root.querySelector('[data-lc-db-context]');
        const progress = root.querySelector('[data-lc-db-progress]');
        counter.textContent = `Frage ${state.step + 1} von ${steps.length}`;
        context.textContent = contexts[state.step];
        progress.setAttribute('aria-valuenow', String(state.step + 1));
        Array.from(progress.children).forEach((bar, index) => bar.classList.toggle('is-active', index <= state.step));
        back.disabled = state.step === 0;
        next.innerHTML = state.step === steps.length - 1
          ? 'Empfehlung anzeigen <span aria-hidden="true">→</span>'
          : 'Weiter <span aria-hidden="true">→</span>';
        if (reposition) scrollToActiveStep();
      };

      const advance = (reposition = true) => {
        if (state.step < steps.length - 1) {
          state.step += 1;
          renderStep(reposition);
        } else {
          renderResult();
        }
      };

      root.querySelectorAll('[data-lc-db-answer]').forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.lcDbAnswer;
          root.querySelectorAll(`[data-lc-db-answer="${key}"]`).forEach((option) => {
            const selected = option === button;
            option.classList.toggle('is-selected', selected);
            option.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          state[key] = button.dataset.value;
          window.clearTimeout(autoAdvanceTimer);
          autoAdvanceTimer = window.setTimeout(() => advance(true), 220);
        });
      });

      usageSelect.addEventListener('change', () => {
        state.usage = usageSelect.value;
        renderSizes();
      });

      sizeSelect.addEventListener('change', () => {
        state.size = sizeSelect.value;
      });

      const desiredWarmth = () => {
        const base = temperatureIndex[state.temperature] ?? 2;
        const offset = feelingOffset[state.feeling] ?? 0;
        return warmthKeys[Math.max(0, Math.min(warmthKeys.length - 1, base + offset))];
      };

      const variantText = (variant) => normalise([variant.title].concat(variant.options || []).join(' '));

      const variantWarmth = (product, variant) => {
        if (product.fixedWarmth) return product.fixedWarmth;
        const text = variantText(variant);
        if (text.includes('extrawarme') || text.includes('extrawinter')) return 'extra';
        if (text.includes('leichteganzjahres')) return 'light';
        if (text.includes('winterdecke')) return 'winter';
        if (text.includes('ganzjahresdecke')) return 'allseason';
        if (text.includes('sommerdecke')) return 'summer';
        return '';
      };

      const sizeMatches = (variant, size) => variantText(variant).includes(normalise(size));

      const exactVariant = (product, size, warmth) => product.variants.find((variant) => {
        if (!variant.available || !sizeMatches(variant, size)) return false;
        return variantWarmth(product, variant) === warmth;
      });

      const nearestVariant = (product, size, warmth) => {
        const desiredIndex = warmthKeys.indexOf(warmth);
        return product.variants
          .filter((variant) => variant.available && sizeMatches(variant, size) && variantWarmth(product, variant))
          .map((variant) => ({
            variant,
            distance: Math.abs(warmthKeys.indexOf(variantWarmth(product, variant)) - desiredIndex)
          }))
          .sort((a, b) => a.distance - b.distance)[0]?.variant || null;
      };

      const productScore = (product) => {
        let score = product.key === 'pure' ? 6 : 0;

        if (state.material === 'open') {
          if (state.feeling === 'hot') {
            if (product.material === 'silk') score += 42;
            if (product.material === 'vegan') score += 18;
            if (product.key === 'pure') score += 15;
            if (product.material === 'camel') score += 12;
          } else if (state.feeling === 'cold') {
            if (product.material === 'camel') score += 36;
            if (product.material === 'down') score += product.quality * 9;
            if (product.material === 'vegan') score += 12;
          } else {
            if (product.key === 'pure') score += 18;
            if (product.key === 'premium') score += 15;
            if (product.material === 'camel') score += 12;
            if (product.material === 'vegan') score += 8;
          }
        } else if (product.material === state.material) {
          score += 80;
        }

        if (product.material === 'down') {
          const qualityTargets = { value: 1, comfort: 2, luxury: 3, exclusive: 4 };
          score += 52 - Math.abs(product.quality - qualityTargets[state.priority]) * 22;
          if (state.priority === 'exclusive' && product.key === 'royal') score += 50;
        } else {
          if (state.priority === 'value' && product.key === 'cosy') score += 28;
          if (state.priority === 'comfort' && ['camel', 'silk', 'cosy'].includes(product.key)) score += 20;
          if (state.priority === 'luxury' && ['camel', 'silk'].includes(product.key)) score += 24;
          if (state.priority === 'exclusive') score -= 8;
        }

        return score;
      };

      const candidatesFor = (warmth, restrictMaterial = true) => {
        const availableProducts = Object.values(products).filter((product) => {
          if (!restrictMaterial || state.material === 'open') return true;
          return product.material === state.material;
        });

        let candidates = availableProducts
          .map((product) => ({ product, variant: exactVariant(product, state.size, warmth), distance: 0 }))
          .filter((candidate) => candidate.variant);

        if (!candidates.length && state.material !== 'open' && restrictMaterial) {
          candidates = availableProducts
            .map((product) => {
              const variant = nearestVariant(product, state.size, warmth);
              const actual = variant ? variantWarmth(product, variant) : '';
              return {
                product,
                variant,
                distance: variant ? Math.abs(warmthKeys.indexOf(actual) - warmthKeys.indexOf(warmth)) : 99
              };
            })
            .filter((candidate) => candidate.variant);
        }

        return candidates
          .map((candidate) => ({ ...candidate, score: productScore(candidate.product) - candidate.distance * 30 }))
          .sort((a, b) => b.score - a.score);
      };

      const materialReason = (product) => {
        const reasons = {
          down: 'Daune verbindet hohe Wärmeleistung mit angenehm geringem Gewicht.',
          silk: 'Seide und Lyocell unterstützen ein kühles, trockenes Schlafklima.',
          camel: 'Kamelhaar wirkt natürlich temperaturausgleichend und wohlig.',
          vegan: 'PrimaLoft Bio® ist vegan, pflegeleicht und unkompliziert im Alltag.'
        };
        return reasons[product.material] || '';
      };

      const productReason = (product) => {
        const reasons = {
          classic: 'Classic ist der hochwertige Einstieg in die LuxeCosy Daunenlinie.',
          premium: 'Premium bietet die mittlere Qualitätsstufe mit besonders feinem Wildentenflaum.',
          pure: 'Pure ist der Bestseller für besonders hohe Bauschkraft und luxuriöse Leichtigkeit.',
          royal: 'Royal ist die exklusivste Sommerdecke aus echter Eiderdaune.',
          silk: 'Diese Materialkombination ist besonders auf warme Nächte und Feuchtigkeitsregulierung ausgerichtet.',
          camel: 'Kamelhaar eignet sich für Menschen, die natürliche, ausgleichende Wärme schätzen.',
          cosy: 'Cosy bietet eine vegane Alternative mit angenehmer Wärme und einfacher Pflege.'
        };
        return reasons[product.key] || '';
      };

      const productUrl = (candidate) => {
        const separator = candidate.product.url.includes('?') ? '&' : '?';
        return candidate.variant?.id ? `${candidate.product.url}${separator}variant=${candidate.variant.id}` : candidate.product.url;
      };

      const alternativePool = (primary, desired) => {
        const allExact = candidatesFor(desired, false).filter((candidate) => candidate.product.key !== primary.product.key);
        const sameProductVariants = primary.product.variants
          .filter((variant) => variant.available && sizeMatches(variant, state.size) && variant.id !== primary.variant.id)
          .map((variant) => ({
            product: primary.product,
            variant,
            distance: Math.abs(warmthKeys.indexOf(variantWarmth(primary.product, variant)) - warmthKeys.indexOf(desired)),
            score: productScore(primary.product) - 15
          }))
          .sort((a, b) => a.distance - b.distance);

        return allExact.concat(sameProductVariants).slice(0, 2);
      };

      const renderAlternatives = (alternatives) => {
        const grid = root.querySelector('[data-lc-db-alternatives]');
        grid.innerHTML = alternatives.map((candidate) => {
          const product = candidate.product;
          const actualWarmth = warmthLabels[variantWarmth(product, candidate.variant)] || candidate.variant.title;
          const image = product.image
            ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" width="240" height="180" loading="lazy">`
            : '<span class="lc-db__alternative-image"></span>';
          return `
            <a class="lc-db__alternative" href="${escapeHtml(productUrl(candidate))}">
              ${image}
              <span class="lc-db__alternative-copy">
                <strong>${escapeHtml(product.title)}</strong>
                <span>${escapeHtml(candidate.variant.price || product.price)}</span>
                <small>${escapeHtml(actualWarmth)} · ${escapeHtml(candidate.variant.title)}</small>
              </span>
            </a>
          `;
        }).join('');
      };

      const renderResult = () => {
        const desired = desiredWarmth();
        let candidates = candidatesFor(desired, true);
        if (!candidates.length) candidates = candidatesFor(desired, false);
        if (!candidates.length) {
          candidates = Object.values(products)
            .map((product) => {
              const variant = nearestVariant(product, state.size, desired);
              const actual = variant ? variantWarmth(product, variant) : '';
              const distance = variant
                ? Math.abs(warmthKeys.indexOf(actual) - warmthKeys.indexOf(desired))
                : 99;
              return { product, variant, distance, score: productScore(product) - distance * 30 };
            })
            .filter((candidate) => candidate.variant)
            .sort((a, b) => b.score - a.score);
        }

        if (!candidates.length) {
          root.querySelector('[data-lc-db-result-title]').textContent = 'Für diese Kombination ist derzeit keine Variante verfügbar';
          root.querySelector('[data-lc-db-result-summary]').textContent = 'Bitte ändern Sie Größe, Material oder Wärmegrad und versuchen Sie es erneut.';
          finder.hidden = true;
          result.hidden = false;
          return;
        }

        const primary = candidates[0];
        const product = primary.product;
        const variant = primary.variant;
        const actualWarmthKey = variantWarmth(product, variant);
        const actualWarmth = warmthLabels[actualWarmthKey] || variant.title;
        state.product = product;
        state.variant = variant;

        root.querySelector('[data-lc-db-result-title]').textContent = product.title;
        root.querySelector('[data-lc-db-result-summary]').textContent =
          `Unsere Empfehlung: ${actualWarmth} in ${state.size.replace('x', ' × ')} cm.`;
        root.querySelector('[data-lc-db-result-variant]').textContent = variant.title;
        root.querySelector('[data-lc-db-result-price]').textContent = variant.price || product.price;
        root.querySelector('[data-lc-db-result-badge]').textContent = product.badge;
        root.querySelector('[data-lc-db-product-link]').href = productUrl(primary);

        const image = root.querySelector('[data-lc-db-result-image]');
        if (product.image) image.src = product.image;
        image.alt = product.title;

        const wantedWarmth = warmthLabels[desired];
        const reasons = [
          `${feelingLabels[state.feeling]}; zusammen mit Ihrer Raumtemperatur ergibt sich ${wantedWarmth}.`,
          actualWarmthKey !== desired
            ? `${wantedWarmth} ist in Ihrem gewählten Material und Ihrer Größe nicht verfügbar. ${actualWarmth} ist die nächstliegende Ausführung.`
            : `${actualWarmth} ist für die gewählte Kombination direkt verfügbar.`,
          materialReason(product),
          productReason(product)
        ];
        root.querySelector('[data-lc-db-reasons]').innerHTML = reasons
          .filter(Boolean)
          .map((reason) => `<li>${escapeHtml(reason)}</li>`)
          .join('');

        const coupleNote = root.querySelector('[data-lc-db-couple-note]');
        coupleNote.hidden = state.usage !== 'separate';

        const cartButton = root.querySelector('[data-lc-db-cart]');
        cartButton.disabled = !variant.available;
        root.querySelector('[data-lc-db-cart-status]').textContent = '';
        renderAlternatives(alternativePool(primary, desired));

        finder.hidden = true;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      next.addEventListener('click', () => {
        window.clearTimeout(autoAdvanceTimer);
        advance(true);
      });

      back.addEventListener('click', () => {
        window.clearTimeout(autoAdvanceTimer);
        if (state.step > 0) {
          state.step -= 1;
          renderStep(true);
        }
      });

      edit.addEventListener('click', () => {
        result.hidden = true;
        finder.hidden = false;
        state.step = 0;
        renderStep();
        finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      root.querySelector('[data-lc-db-cart]').addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const status = root.querySelector('[data-lc-db-cart-status]');
        if (!state.variant) return;

        button.disabled = true;
        status.textContent = 'Die Bettdecke wird hinzugefügt …';
        try {
          const rootPath = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(state.variant.id), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('cart');
          status.textContent = 'Die Bettdecke wurde in den Warenkorb gelegt.';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (error) {
          status.textContent = 'Das Hinzufügen hat nicht funktioniert. Bitte öffnen Sie die Produktseite.';
          button.disabled = false;
        }
      });

      renderSizes();
      renderStep();
    };

    const initialiseAll = () => document.querySelectorAll('[data-lc-db]').forEach(initialise);
    initialiseAll();
    document.addEventListener('shopify:section:load', initialiseAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxecosy-bettwaescheberater"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalise = (value) => String(value || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '').replace(/[()]/g, '').replace(/ß/g, 'ss');
    const escapeHtml = (value) => String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');

    const initialise = (root) => {
      if (root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';

      const products = {};
      root.querySelectorAll('[data-lc-bw-product]').forEach((script) => {
        try {
          const product = JSON.parse(script.textContent);
          if (product?.key) products[product.key] = product;
        } catch (error) {
          script.dataset.invalid = 'true';
        }
      });

      const finder = root.querySelector('[data-lc-bw-finder]');
      const result = root.querySelector('[data-lc-bw-result]');
      const steps = Array.from(root.querySelectorAll('[data-lc-bw-step]'));
      const next = root.querySelector('[data-lc-bw-next]');
      const back = root.querySelector('[data-lc-bw-back]');
      const state = {
        step: 0, climate: 'balanced', touch: 'fresh', look: 'timeless', priority: 'easy',
        beddingSize: '135x200', colour: 'white', sheetWanted: 'yes',
        mattressSize: '90-100', mattressHeight: 'standard', product: null, variant: null
      };
      let timer;
      const contexts = ['Ihr Schlafklima', 'Ihre bevorzugte Haptik', 'Ihre gewünschte Optik', 'Pflege und Prioritäten', 'Größen und passende Ergänzung'];
      const colourTerms = {
        white: ['weiss'],
        blue: ['dunkelblau', 'marine', 'hellblau', 'blau', 'mint'],
        neutral: ['beige', 'hellgrau', 'grau', 'graphit', 'schwarz', 'anthrazit'],
        colourful: ['gruen', 'rot', 'rosa', 'altrosa', 'altrose', 'mint']
      };
      const copy = {
        renforce: { summary: 'Der frische, pflegeleichte Allrounder aus GOTS Bio-Baumwolle.', material: 'Renforcé fühlt sich glatt, leicht und angenehm frisch an.', care: 'Die robuste Baumwollqualität ist unkompliziert, formstabil und bis 60 °C waschbar.' },
        satin: { summary: 'Die seidig glatte Luxuswahl mit elegantem Schimmer.', material: 'Mako-Satin aus feiner Baumwolle bietet eine besonders glatte, weiche Oberfläche.', care: 'Die dichte Webart wirkt elegant, bleibt atmungsaktiv und ist bis 60 °C waschbar.' },
        muslin: { summary: 'Die luftige, weiche Wahl für einen entspannten und modernen Look.', material: 'Musselin ist locker gewebt, anschmiegsam und durch seine Kreppstruktur besonders lässig.', care: 'Die Oberfläche darf bewusst ungebügelt wirken und wird bei maximal 40 °C gewaschen.' }
      };

      const variantText = (variant) => normalise([variant.title].concat(variant.options || []).join(' '));
      const sizeVariant = (product, size) => product?.variants?.find((variant) => variantText(variant).includes(normalise(size))) || null;
      const exactVariant = (product, size, colour) => {
        const terms = colourTerms[colour] || [];
        return product?.variants?.find((variant) => {
          const text = variantText(variant);
          return text.includes(normalise(size)) && terms.some((term) => text.includes(term));
        }) || sizeVariant(product, size);
      };
      const score = (product) => {
        let value = product.key === 'renforce' ? 6 : 0;
        if (state.climate === 'hot') value += product.key === 'muslin' ? 48 : product.key === 'renforce' ? 30 : 20;
        if (state.climate === 'balanced') value += product.key === 'renforce' ? 38 : 25;
        if (state.climate === 'cold') value += product.key === 'satin' ? 42 : product.key === 'muslin' ? 22 : 20;
        if (state.touch === 'fresh') value += product.key === 'renforce' ? 65 : 5;
        if (state.touch === 'silky') value += product.key === 'satin' ? 70 : 5;
        if (state.touch === 'soft') value += product.key === 'muslin' ? 70 : 8;
        if (state.look === 'timeless') value += product.key === 'renforce' ? 50 : 8;
        if (state.look === 'elegant') value += product.key === 'satin' ? 55 : 5;
        if (state.look === 'relaxed') value += product.key === 'muslin' ? 55 : 5;
        if (state.priority === 'easy') value += product.key === 'renforce' ? 45 : product.key === 'muslin' ? 25 : 15;
        if (state.priority === 'natural') value += product.key === 'renforce' ? 55 : product.key === 'muslin' ? 25 : 10;
        if (state.priority === 'luxury') value += product.key === 'satin' ? 65 : 8;
        return value;
      };
      const candidates = () => ['renforce', 'satin', 'muslin'].map((key) => {
        const product = products[key];
        const variant = exactVariant(product, state.beddingSize, state.colour);
        return { product, variant, score: product ? score(product) : 0 };
      }).filter((item) => item.product && item.variant).sort((a, b) => b.score - a.score);
      const productUrl = (product, variant) => {
        const separator = product.url.includes('?') ? '&' : '?';
        return variant?.id ? `${product.url}${separator}variant=${variant.id}` : product.url;
      };
      const scrollStep = () => {
        if (!window.matchMedia('(max-width:680px)').matches) return;
        requestAnimationFrame(() => steps[state.step]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'start' }));
      };
      const renderStep = (reposition = false) => {
        steps.forEach((step, index) => step.classList.toggle('is-active', index === state.step));
        root.querySelector('[data-lc-bw-counter]').textContent = `Frage ${state.step + 1} von ${steps.length}`;
        root.querySelector('[data-lc-bw-context]').textContent = contexts[state.step];
        const progress = root.querySelector('[data-lc-bw-progress]');
        progress.setAttribute('aria-valuenow', String(state.step + 1));
        Array.from(progress.children).forEach((bar, index) => bar.classList.toggle('is-active', index <= state.step));
        back.disabled = state.step === 0;
        next.innerHTML = state.step === steps.length - 1 ? 'Empfehlung anzeigen <span aria-hidden="true">→</span>' : 'Weiter <span aria-hidden="true">→</span>';
        if (reposition) scrollStep();
      };
      const sheetVariant = (product) => exactVariant(product, state.mattressSize, state.colour);
      const chooseSheet = () => {
        let key = 'jersey';
        if (state.climate === 'hot') key = 'bamboo';
        if (state.priority === 'luxury') key = 'luxuryJersey';
        const preferred = products[key];
        let variant = sheetVariant(preferred);
        if (variant) return { product: preferred, variant };
        return ['jersey', 'bamboo', 'luxuryJersey'].map((sheetKey) => ({ product: products[sheetKey], variant: sheetVariant(products[sheetKey]) })).find((item) => item.product && item.variant) || null;
      };
      const renderAlternatives = (items) => {
        root.querySelector('[data-lc-bw-alternatives]').innerHTML = items.slice(1, 3).map(({ product, variant }) => `
          <a class="lc-bw__alternative" href="${escapeHtml(productUrl(product, variant))}">
            <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" width="220" height="160" loading="lazy">
            <span><strong>${escapeHtml(product.title)}</strong><small>${escapeHtml(product.badge)} · ${escapeHtml(variant.title)}</small></span>
          </a>`).join('');
      };
      const renderSheet = () => {
        const card = root.querySelector('[data-lc-bw-sheet-result]');
        if (state.sheetWanted === 'no') {
          card.hidden = true;
          return;
        }
        const chosen = chooseSheet();
        if (!chosen || state.mattressHeight === 'special') {
          card.hidden = false;
          root.querySelector('[data-lc-bw-sheet-title]').textContent = 'Spannbettlaken mit persönlicher Passformprüfung';
          root.querySelector('[data-lc-bw-sheet-summary]').textContent = 'Bei mehr als 35 cm Gesamthöhe sollte die Steghöhe vor dem Kauf individuell geprüft werden.';
          root.querySelector('[data-lc-bw-sheet-variant]').textContent = 'Persönliche Beratung empfohlen';
          root.querySelector('[data-lc-bw-sheet-price]').textContent = '';
          root.querySelector('[data-lc-bw-sheet-link]').href = '/pages/kontakt';
          root.querySelector('[data-lc-bw-sheet-image]').removeAttribute('src');
          return;
        }
        const { product, variant } = chosen;
        const summaries = {
          jersey: 'Die pflegeleichte Alltagslösung aus weichem Fein-Jersey.',
          bamboo: 'Die besonders weiche und klimaregulierende Empfehlung.',
          luxuryJersey: 'Die dichte Premium-Empfehlung für einen besonders glatten, luxuriösen Sitz.'
        };
        card.hidden = false;
        root.querySelector('[data-lc-bw-sheet-title]').textContent = product.title;
        root.querySelector('[data-lc-bw-sheet-summary]').textContent = summaries[product.key];
        root.querySelector('[data-lc-bw-sheet-variant]').textContent = variant.title;
        root.querySelector('[data-lc-bw-sheet-price]').textContent = variant.price || product.price;
        root.querySelector('[data-lc-bw-sheet-link]').href = productUrl(product, variant);
        const image = root.querySelector('[data-lc-bw-sheet-image]');
        if (product.image) image.src = product.image;
        image.alt = product.title;
      };
      const renderResult = () => {
        const items = candidates();
        if (!items.length) {
          root.querySelector('[data-lc-bw-result-title]').textContent = 'Diese Kombination ist derzeit nicht als Variante hinterlegt';
          root.querySelector('[data-lc-bw-result-summary]').textContent = 'Bitte ändern Sie Bettwäschegröße oder Farbwelt.';
          finder.hidden = true; result.hidden = false; result.scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
        }
        const { product, variant } = items[0];
        state.product = product; state.variant = variant;
        root.querySelector('[data-lc-bw-result-title]').textContent = product.title;
        root.querySelector('[data-lc-bw-result-summary]').textContent = copy[product.key].summary;
        root.querySelector('[data-lc-bw-result-variant]').textContent = variant.title;
        root.querySelector('[data-lc-bw-result-price]').textContent = variant.price || product.price;
        root.querySelector('[data-lc-bw-result-badge]').textContent = product.badge;
        root.querySelector('[data-lc-bw-product-link]').href = productUrl(product, variant);
        const image = root.querySelector('[data-lc-bw-result-image]'); if (product.image) image.src = product.image; image.alt = product.title;
        const reasons = [copy[product.key].material, copy[product.key].care, `Ihre Angaben zu Haptik und Optik sprechen besonders für ${product.badge.split(' · ')[0]}.`];
        root.querySelector('[data-lc-bw-reasons]').innerHTML = reasons.map((reason) => `<li>${escapeHtml(reason)}</li>`).join('');
        const cart = root.querySelector('[data-lc-bw-cart]');
        cart.disabled = !variant.available; cart.textContent = variant.available ? 'In den Warenkorb' : 'Bald verfügbar';
        root.querySelector('[data-lc-bw-availability]').textContent = variant.available ? 'Farbe und Größe wurden als konkrete Variante berücksichtigt.' : 'Diese Variante wird empfohlen, ist aktuell jedoch noch nicht kaufbar. Weitere Informationen finden Sie auf der Produktseite.';
        renderSheet(); renderAlternatives(items);
        finder.hidden = true; result.hidden = false; result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      const advance = () => { if (state.step < steps.length - 1) { state.step += 1; renderStep(true); } else renderResult(); };

      root.querySelectorAll('[data-lc-bw-answer]').forEach((button) => button.addEventListener('click', () => {
        const key = button.dataset.lcBwAnswer;
        root.querySelectorAll(`[data-lc-bw-answer="${key}"]`).forEach((option) => { const selected = option === button; option.classList.toggle('is-selected', selected); option.setAttribute('aria-pressed', selected ? 'true' : 'false'); });
        state[key] = button.dataset.value; clearTimeout(timer); timer = setTimeout(advance, 220);
      }));
      root.querySelectorAll('[data-lc-bw-select]').forEach((select) => select.addEventListener('change', () => {
        state[select.dataset.lcBwSelect] = select.value;
        if (select.dataset.lcBwSelect === 'sheetWanted') root.querySelectorAll('[data-lc-bw-sheet-field]').forEach((field) => { field.hidden = state.sheetWanted === 'no'; });
      }));
      next.addEventListener('click', () => { clearTimeout(timer); advance(); });
      back.addEventListener('click', () => { clearTimeout(timer); if (state.step > 0) { state.step -= 1; renderStep(true); } });
      root.querySelector('[data-lc-bw-edit]').addEventListener('click', () => { result.hidden = true; finder.hidden = false; state.step = 0; renderStep(); finder.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      root.querySelector('[data-lc-bw-cart]').addEventListener('click', async (event) => {
        if (!state.variant?.available) return;
        const button = event.currentTarget, status = root.querySelector('[data-lc-bw-cart-status]'); button.disabled = true; status.textContent = 'Die Bettwäsche wird hinzugefügt …';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(state.variant.id), quantity: 1 }] }) });
          if (!response.ok) throw new Error('cart');
          status.textContent = 'Die Bettwäsche wurde in den Warenkorb gelegt.'; document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (error) { status.textContent = 'Das Hinzufügen hat nicht funktioniert. Bitte öffnen Sie die Produktseite.'; button.disabled = false; }
      });
      renderStep();
    };
    const initialiseAll = () => document.querySelectorAll('[data-lc-bw]').forEach(initialise);
    initialiseAll(); document.addEventListener('shopify:section:load', initialiseAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxecosy-kissenberater"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalise = (value) => String(value || '')
      .toLowerCase()
      .replace(/×/g, 'x')
      .replace(/\s+/g, '')
      .replace(/[()]/g, '');

    const initialise = (root) => {
      if (root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';

      const finder = root.querySelector('[data-lc-kb-finder]');
      const result = root.querySelector('[data-lc-kb-result]');
      const steps = Array.from(root.querySelectorAll('[data-lc-kb-step]'));
      const progressParts = Array.from(root.querySelectorAll('[data-lc-kb-progress] span'));
      const progress = root.querySelector('[data-lc-kb-progress]');
      const counter = root.querySelector('[data-lc-kb-counter]');
      const context = root.querySelector('[data-lc-kb-context]');
      const back = root.querySelector('[data-lc-kb-back]');
      const next = root.querySelector('[data-lc-kb-next]');
      const edit = root.querySelector('[data-lc-kb-edit]');
      const translations = JSON.parse(root.querySelector('[data-lc-kb-translations]').textContent);
      const products = {};

      root.querySelectorAll('[data-lc-kb-product]').forEach((script) => {
        const product = JSON.parse(script.textContent);
        products[product.key] = product;
      });

      const state = {
        step: 0,
        sleep: 'side',
        shoulder: 'medium',
        mattress: 'medium',
        feel: 'balanced',
        priority: 'entry',
        size: '40x80',
        product: null,
        variant: null
      };
      let autoAdvanceTimer;

      const productForPriority = {
        entry: 'classic',
        adjustable: 'pure',
        material: 'premium',
        cloud: 'royal',
        vegan: 'cosy'
      };

      const supportsSize = (product, size) => {
        if (!product || !product.variants) return false;
        return product.variants.some((variant) => normalise(variant.title).includes(normalise(size)));
      };

      const updateSizeAvailability = () => {
        const product = products[productForPriority[state.priority]];
        const sizeButtons = Array.from(root.querySelectorAll('[data-lc-kb-answer="size"]'));
        sizeButtons.forEach((button) => {
          button.disabled = !supportsSize(product, button.dataset.value);
        });

        const selected = sizeButtons.find((button) => button.dataset.value === state.size);
        if (!selected || selected.disabled) {
          const firstAvailable = sizeButtons.find((button) => !button.disabled);
          if (firstAvailable) {
            sizeButtons.forEach((button) => {
              const isSelected = button === firstAvailable;
              button.classList.toggle('is-selected', isSelected);
              button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            });
            state.size = firstAvailable.dataset.value;
          }
        }
      };

      const scrollToActiveStep = () => {
        if (!window.matchMedia('(max-width: 680px)').matches) return;
        const activeStep = steps[state.step];
        if (!activeStep) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.requestAnimationFrame(() => {
          activeStep.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      };

      const renderStep = (reposition = false) => {
        steps.forEach((step, index) => step.classList.toggle('is-active', index === state.step));
        progressParts.forEach((part, index) => part.classList.toggle('is-active', index <= state.step));
        progress.setAttribute('aria-valuenow', String(state.step + 1));
        counter.textContent = translations.progress
          .replace('[current]', String(state.step + 1))
          .replace('[total]', String(steps.length));
        context.textContent = translations.context[state.step];
        back.disabled = state.step === 0;
        next.innerHTML = `${state.step === steps.length - 1 ? translations.showResult : translations.next} <span aria-hidden="true">→</span>`;
        if (state.step === steps.length - 1) updateSizeAvailability();
        if (reposition) scrollToActiveStep();
      };

      const advance = (reposition = true) => {
        if (state.step < steps.length - 1) {
          state.step += 1;
          renderStep(reposition);
        } else {
          renderResult();
        }
      };

      const setAnswer = (button) => {
        const key = button.dataset.lcKbAnswer;
        const value = button.dataset.value;
        state[key] = value;
        root.querySelectorAll(`[data-lc-kb-answer="${key}"]`).forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (key === 'priority') updateSizeAvailability();
        if (key === 'size') {
          const hint = root.querySelector('[data-lc-kb-size-hint]');
          hint.textContent = value === '40x80' || value === '50x70' || value === '60x80' || value === '70x90'
            ? translations.sizeRectangular
            : translations.sizeSquare;
        }
      };

      root.querySelectorAll('[data-lc-kb-answer]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          setAnswer(button);
          window.clearTimeout(autoAdvanceTimer);
          autoAdvanceTimer = window.setTimeout(() => advance(true), 220);
        });
      });

      root.querySelectorAll('[data-lc-kb-select]').forEach((select) => {
        select.addEventListener('change', () => {
          state[select.dataset.lcKbSelect] = select.value;
        });
      });

      const supportLevel = () => {
        let score = 1;
        if (state.sleep === 'side') score += 1;
        if (state.sleep === 'stomach') score -= 2;
        if (state.shoulder === 'broad') score += 1;
        if (state.shoulder === 'narrow') score -= 1;
        if (state.mattress === 'firm') score += 1;
        if (state.mattress === 'soft') score -= 1;
        if (state.feel === 'supportive') score += 1;
        if (state.feel === 'soft') score -= 1;
        if (score <= 0) return 'soft';
        if (score >= 4) return 'firm';
        return 'medium';
      };

      const variantFor = (product, size, support) => {
        if (!product || !product.variants || product.variants.length === 0) return null;
        const sizeVariants = product.variants.filter((variant) => normalise(variant.title).includes(normalise(size)));
        if (sizeVariants.length === 0) return product.variants.find((variant) => variant.available) || product.variants[0];
        if (product.key === 'pure') {
          const supportTerms = {
            soft: ['weich'],
            medium: ['medium', 'bestseller'],
            firm: ['fest']
          };
          const exact = sizeVariants.find((variant) => {
            const title = normalise(variant.title);
            return supportTerms[support].some((term) => title.includes(term));
          });
          if (exact) return exact;
        }
        return sizeVariants.find((variant) => variant.available) || sizeVariants[0];
      };

      const productKey = () => {
        const preferred = productForPriority[state.priority];
        if (supportsSize(products[preferred], state.size)) return preferred;
        if (state.priority === 'entry' && supportsSize(products.pure, state.size)) return 'pure';
        if (state.priority === 'vegan') return 'cosy';
        return ['pure', 'premium', 'royal', 'classic'].find((key) => supportsSize(products[key], state.size)) || preferred;
      };

      const supportName = (support) => {
        if (support === 'soft') return translations.supportSoft;
        if (support === 'firm') return translations.supportFirm;
        return translations.supportMedium;
      };

      const positionSummary = () => {
        if (state.sleep === 'back') return translations.summaryBack;
        if (state.sleep === 'stomach') return translations.summaryStomach;
        if (state.sleep === 'mixed') return translations.summaryMixed;
        return translations.summarySide;
      };

      const alternativeKeys = (primaryKey) => {
        let preferred = ['classic', 'premium', 'pure', 'royal', 'cosy'];
        if (state.priority === 'entry') preferred = ['premium', 'pure'];
        if (state.priority === 'material') preferred = ['classic', 'pure'];
        if (state.priority === 'adjustable') preferred = ['premium', 'classic'];
        if (state.priority === 'cloud') preferred = ['pure', 'premium'];
        if (state.priority === 'vegan') preferred = ['classic', 'premium'];
        return preferred
          .filter((key) => key !== primaryKey && products[key] && supportsSize(products[key], state.size))
          .slice(0, 2);
      };

      const renderAlternatives = (keys) => {
        const container = root.querySelector('[data-lc-kb-alternatives]');
        container.innerHTML = keys.map((key) => {
          const product = products[key];
          const variant = variantFor(product, state.size, supportLevel());
          const price = variant ? variant.price : product.price;
          return `
            <a class="lc-kb__alternative" href="${product.url}">
              <img src="${product.image}" alt="${product.imageAlt || product.title}" width="360" height="280" loading="lazy">
              <span class="lc-kb__alternative-copy">
                <strong>${product.title}</strong>
                <span>${price}</span>
                <small>${translations.alternativeReason}</small>
              </span>
            </a>
          `;
        }).join('');
      };

      const renderResult = () => {
        const key = productKey();
        const product = products[key];
        const support = supportLevel();
        const variant = variantFor(product, state.size, support);
        state.product = product;
        state.variant = variant;

        root.querySelector('[data-lc-kb-result-title]').textContent = product.title;
        root.querySelector('[data-lc-kb-result-summary]').textContent = positionSummary();
        root.querySelector('[data-lc-kb-result-image]').src = product.image;
        root.querySelector('[data-lc-kb-result-image]').alt = product.imageAlt || product.title;
        root.querySelector('[data-lc-kb-result-badge]').textContent = product.badge;
        root.querySelector('[data-lc-kb-result-variant]').textContent = variant
          ? `${translations.variantLabel}: ${variant.title}`
          : translations.sizeUnavailable;
        root.querySelector('[data-lc-kb-result-price]').textContent = variant
          ? variant.price
          : `${translations.fromPrice} ${product.price}`;
        root.querySelector('[data-lc-kb-product-link]').href = product.url;

        const reasons = [
          translations.reasonPosition.replace('[support]', supportName(support)),
          translations.reasonFeel,
          translations.reasonProduct.replace('[badge]', product.badge)
        ];
        root.querySelector('[data-lc-kb-reasons]').innerHTML = reasons.map((reason) => `<li>${reason}</li>`).join('');

        const cartButton = root.querySelector('[data-lc-kb-cart]');
        cartButton.disabled = !variant || !variant.available;
        root.querySelector('[data-lc-kb-cart-status]').textContent = !variant ? translations.sizeUnavailable : '';
        renderAlternatives(alternativeKeys(key));

        finder.hidden = true;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      next.addEventListener('click', () => {
        window.clearTimeout(autoAdvanceTimer);
        advance(true);
      });

      back.addEventListener('click', () => {
        window.clearTimeout(autoAdvanceTimer);
        if (state.step > 0) {
          state.step -= 1;
          renderStep(true);
        }
      });

      edit.addEventListener('click', () => {
        window.clearTimeout(autoAdvanceTimer);
        result.hidden = true;
        finder.hidden = false;
        state.step = 0;
        renderStep();
        finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      root.querySelector('[data-lc-kb-cart]').addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const status = root.querySelector('[data-lc-kb-cart-status]');
        if (!state.variant) return;

        button.disabled = true;
        status.textContent = translations.adding;
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(state.variant.id), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('cart');
          status.textContent = translations.added;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (error) {
          status.textContent = translations.addError;
          button.disabled = false;
        }
      });

      renderStep();
    };

    const initialiseAll = () => {
      document.querySelectorAll('[data-lc-kb]').forEach(initialise);
    };

    initialiseAll();
    document.addEventListener('shopify:section:load', initialiseAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxecosy-topperberater"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalise = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/×/g, 'x')
        .replace(/\s+/g, '')
        .replace(/[()]/g, '');

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    const initialise = (root) => {
      if (root.dataset.initialised === 'true') return;

      root.dataset.initialised = 'true';

      const products = {};

      root.querySelectorAll('[data-lc-tb-product]').forEach((script) => {
        try {
          const product = JSON.parse(script.textContent);

          if (
            product &&
            product.key &&
            Array.isArray(product.variants)
          ) {
            products[product.key] = product;
          }
        } catch (error) {
          script.dataset.invalid = 'true';
        }
      });

      const finder = root.querySelector('[data-lc-tb-finder]');
      const result = root.querySelector('[data-lc-tb-result]');
      const steps = Array.from(
        root.querySelectorAll('[data-lc-tb-step]')
      );
      const next = root.querySelector('[data-lc-tb-next]');
      const back = root.querySelector('[data-lc-tb-back]');
      const edit = root.querySelector('[data-lc-tb-edit]');

      const state = {
        step: 0,
        goal: 'hotel',
        mattress: 'firm',
        climate: 'balanced',
        feel: 'supportive',
        size: '90x200',
        product: null,
        variant: null
      };

      let autoAdvanceTimer;

      const contexts = [
        'Ihr wichtigstes Ziel',
        'Ihre Matratze',
        'Ihr Schlafklima',
        'Ihr gewünschtes Liegegefühl',
        'Ihre Matratzengröße'
      ];

      const productCopy = {
        tencel: {
          summary:
            'Die leichte Matratzenauflage für ein angenehm luftiges und ausgeglichenes Schlafklima.',
          material:
            'Die Füllung aus 100 % TENCEL™ Lyocell kann Feuchtigkeit aufnehmen und unterstützt ein angenehm leichtes Schlafgefühl.',
          structure:
            'Mit 2–3 cm Höhe ergänzt die Auflage die Matratze sanft, ohne deren Grundgefühl stark zu überdecken.',
          decision:
            'Ideal, wenn Ihnen ein leichtes Schlafklima und eine sanfte Komfortschicht wichtiger sind als eine deutlich höhere Polsterung.'
        },

        feather: {
          summary:
            'Der federnde Topper für eine flauschige Komfortschicht mit klassischem Hotelgefühl.',
          material:
            'Die Füllung besteht aus 85 % Federn und 15 % Daunen. Dadurch fühlt sich der Topper flauschig, federnd und etwas strukturierter an.',
          structure:
            'Mit ca. 6 cm Höhe ergänzt der Feder-Topper eine deutlich wahrnehmbare Komfortschicht auf Ihrer Matratze.',
          decision:
            'Ideal, wenn Sie eine federndere Polsterung, mehr Struktur und ein klassisches Hotelgefühl suchen.'
        },

        down: {
          summary:
            'Die luxuriöse Wahl für ein besonders weiches, wolkiges und anschmiegsames Liegegefühl.',
          material:
            'Die Füllung besteht aus 60 % Daunen und 40 % Federn und vermittelt ein besonders weiches und anschmiegsames Liegegefühl.',
          structure:
            'Mit ca. 6 cm Höhe entsteht eine deutlich wahrnehmbare, besonders weiche Komfortschicht.',
          decision:
            'Ideal, wenn luxuriöse Weichheit und ein wolkiges Liegegefühl für Sie an erster Stelle stehen.'
        },

        latex: {
          summary:
            'Der punktelastische Naturlatex-Topper für gezielte Druckentlastung und elastischen Halt.',
          material:
            'Naturlatex reagiert punktgenau auf Schulter und Hüfte. So kann der Körper gezielt nachgeben, während die Oberfläche stützend bleibt.',
          structure:
            'Die Ausführung Weich betont Anschmiegsamkeit und Druckentlastung. Fest bietet mehr Oberflächenspannung und reduziert die Einsinktiefe.',
          decision:
            'Ideal, wenn Sie nicht wolkig einsinken, sondern eine elastische, körpergerechte Komfortschicht wünschen.'
        }
      };

      const goalReasons = {
        cooling:
          'Sie wünschen sich vor allem ein leichteres und ausgeglicheneres Schlafklima.',
        hotel:
          'Sie wünschen sich mehr Komfort mit einem spürbaren Hotelgefühl.',
        luxury:
          'Sie suchen ein besonders weiches und luxuriöses Liegegefühl.',
        open:
          'Sie waren beim Material offen. Deshalb gewichten wir Matratzengefühl, Schlafklima und gewünschten Komfort stärker.'
      };

      const mattressReasons = {
        firm:
          'Ihre Matratzenoberfläche soll sich weicher und anschmiegsamer anfühlen.',
        gap:
          'Sie wünschen sich eine ruhigere und gleichmäßigere Liegefläche.',
        comfortable:
          'Das Grundgefühl Ihrer Matratze darf weitgehend erhalten bleiben.'
      };

      const climateReasons = {
        hot:
          'Da Sie schnell schwitzen, erhält ein leichtes Material mit guter Feuchtigkeitsaufnahme besonderes Gewicht.',
        balanced:
          'Ihr ausgeglichenes Wärmeempfinden lässt grundsätzlich alle Materialvarianten zu.',
        cold:
          'Da Sie schnell frieren, gewichten wir eine weichere und geborgenere Komfortschicht stärker.'
      };

      const feelReasons = {
        light:
          'Sie möchten das Grundgefühl Ihrer Matratze erhalten und es nur sanft ergänzen.',
        supportive:
          'Sie wünschen sich eine spürbare Komfortschicht mit Struktur und Halt.',
        cloud:
          'Sie möchten besonders weich und wolkig liegen.',
        elastic:
          'Sie wünschen sich gezielte Druckentlastung mit elastischem Halt statt tiefem Einsinken.'
      };

      const sizeLabel = (size) =>
        String(size || '').replace('x', ' × ') + ' cm';

      const variantText = (variant) =>
        normalise(
          [variant.title]
            .concat(variant.options || [])
            .join(' ')
        );

      const sizeMatches = (variant, size) =>
        variantText(variant).includes(normalise(size));

      const latexFirmness = () => {
        if (state.mattress === 'gap') return 'firm';
        if (state.feel === 'supportive') return 'firm';
        return 'soft';
      };

      const variantFor = (product, size) => {
        const matchingVariants = (product?.variants || []).filter(
          (variant) => sizeMatches(variant, size)
        );

        if (product?.key !== 'latex') {
          return matchingVariants[0] || null;
        }

        const requestedFirmness = latexFirmness();

        return matchingVariants.find((variant) => {
          const text = variantText(variant);

          return requestedFirmness === 'firm'
            ? text.includes('fest') || text.includes('firm')
            : text.includes('weich') || text.includes('soft');
        }) || matchingVariants[0] || null;
      };

      const updateSizeAvailability = () => {
        const sizeButtons = Array.from(
          root.querySelectorAll('[data-lc-tb-answer="size"]')
        );

        sizeButtons.forEach((button) => {
          button.disabled = !Object.values(products).some(
            (product) =>
              variantFor(product, button.dataset.value)
          );
        });

        const selected = sizeButtons.find(
          (button) =>
            button.dataset.value === state.size &&
            !button.disabled
        );

        if (selected) return;

        const firstAvailable = sizeButtons.find(
          (button) => !button.disabled
        );

        if (!firstAvailable) return;

        sizeButtons.forEach((button) => {
          const isSelected = button === firstAvailable;

          button.classList.toggle(
            'is-selected',
            isSelected
          );

          button.setAttribute(
            'aria-pressed',
            isSelected ? 'true' : 'false'
          );
        });

        state.size = firstAvailable.dataset.value;
      };

      const scrollToActiveStep = () => {
        if (
          !window.matchMedia('(max-width: 680px)').matches
        ) {
          return;
        }

        const activeStep = steps[state.step];

        if (!activeStep) return;

        const reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        window.requestAnimationFrame(() => {
          activeStep.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      };

      const renderStep = (reposition = false) => {
        steps.forEach((step, index) => {
          step.classList.toggle(
            'is-active',
            index === state.step
          );
        });

        const counter = root.querySelector(
          '[data-lc-tb-counter]'
        );
        const context = root.querySelector(
          '[data-lc-tb-context]'
        );
        const progress = root.querySelector(
          '[data-lc-tb-progress]'
        );

        counter.textContent =
          `Frage ${state.step + 1} von ${steps.length}`;

        context.textContent = contexts[state.step];

        progress.setAttribute(
          'aria-valuenow',
          String(state.step + 1)
        );

        Array.from(progress.children).forEach(
          (bar, index) => {
            bar.classList.toggle(
              'is-active',
              index <= state.step
            );
          }
        );

        back.disabled = state.step === 0;

        next.innerHTML =
          state.step === steps.length - 1
            ? 'Empfehlung anzeigen <span aria-hidden="true">→</span>'
            : 'Weiter <span aria-hidden="true">→</span>';

        if (state.step === steps.length - 1) {
          updateSizeAvailability();
        }

        if (reposition) {
          scrollToActiveStep();
        }
      };

      const productScore = (product) => {
        let score = product.key === 'feather' ? 8 : 0;

        if (state.goal === 'cooling') {
          if (product.key === 'tencel') score += 90;
          if (product.key === 'feather') score += 12;
          if (product.key === 'latex') score += 28;
        } else if (state.goal === 'hotel') {
          if (product.key === 'feather') score += 90;
          if (product.key === 'down') score += 28;
          if (product.key === 'latex') score += 18;
        } else if (state.goal === 'luxury') {
          if (product.key === 'down') score += 90;
          if (product.key === 'feather') score += 30;
          if (product.key === 'latex') score += 14;
        } else {
          if (product.key === 'tencel') score += 20;
          if (product.key === 'feather') score += 30;
          if (product.key === 'down') score += 30;
          if (product.key === 'latex') score += 32;
        }

        if (state.mattress === 'firm') {
          if (product.key === 'feather') score += 40;
          if (product.key === 'down') score += 35;
          if (product.key === 'tencel') score += 8;
          if (product.key === 'latex') score += 58;
        } else if (state.mattress === 'gap') {
          if (product.key === 'feather') score += 45;
          if (product.key === 'down') score += 25;
          if (product.key === 'tencel') score += 8;
          if (product.key === 'latex') score += 38;
        } else if (product.key === 'tencel') {
          score += 35;
        } else if (product.key === 'latex') {
          score += 18;
        }

        if (state.climate === 'hot') {
          if (product.key === 'tencel') score += 55;
          if (product.key === 'feather') score += 15;
          if (product.key === 'down') score += 5;
          if (product.key === 'latex') score += 25;
        } else if (state.climate === 'cold') {
          if (product.key === 'feather') score += 30;
          if (product.key === 'down') score += 45;
          if (product.key === 'latex') score += 8;
        } else {
          if (product.key === 'tencel') score += 15;
          if (product.key === 'feather') score += 25;
          if (product.key === 'down') score += 25;
          if (product.key === 'latex') score += 28;
        }

        if (state.feel === 'light') {
          if (product.key === 'tencel') score += 65;
          if (product.key === 'feather') score += 10;
          if (product.key === 'down') score += 10;
          if (product.key === 'latex') score += 5;
        } else if (state.feel === 'supportive') {
          if (product.key === 'feather') score += 65;
          if (product.key === 'down') score += 20;
          if (product.key === 'tencel') score += 5;
          if (product.key === 'latex') score += 42;
        } else if (state.feel === 'cloud') {
          if (product.key === 'down') score += 70;
          if (product.key === 'feather') score += 25;
          if (product.key === 'tencel') score += 5;
          if (product.key === 'latex') score += 8;
        } else if (product.key === 'latex') {
          score += 105;
        }

        return score;
      };

      const candidates = () =>
        Object.values(products)
          .map((product) => ({
            product,
            variant: variantFor(product, state.size),
            score: productScore(product)
          }))
          .filter((candidate) => candidate.variant)
          .sort((a, b) => b.score - a.score);

      const productUrl = (candidate) => {
        const separator =
          candidate.product.url.includes('?') ? '&' : '?';

        return candidate.variant?.id
          ? `${candidate.product.url}${separator}variant=${candidate.variant.id}`
          : candidate.product.url;
      };

      const renderAlternatives = (allCandidates) => {
        const grid = root.querySelector(
          '[data-lc-tb-alternatives]'
        );

        const alternatives = allCandidates.slice(1, 3);

        grid.innerHTML = alternatives
          .map((candidate) => {
            const product = candidate.product;

            const image = product.image
              ? `<img
                  src="${escapeHtml(product.image)}"
                  alt="${escapeHtml(
                    product.imageAlt || product.title
                  )}"
                  width="240"
                  height="180"
                  loading="lazy"
                >`
              : '<span class="lc-tb__alternative-image"></span>';

            return `
              <a
                class="lc-tb__alternative"
                href="${escapeHtml(productUrl(candidate))}"
              >
                ${image}

                <span class="lc-tb__alternative-copy">
                  <strong>${escapeHtml(product.title)}</strong>
                  <span>${escapeHtml(
                    candidate.variant.price || product.price
                  )}</span>
                  <small>
                    ${escapeHtml(product.badge)} ·
                    ${escapeHtml(candidate.variant.title)}
                  </small>
                </span>
              </a>
            `;
          })
          .join('');

        const alternativesSection = root.querySelector(
          '.lc-tb__alternatives'
        );

        if (alternativesSection) {
          alternativesSection.hidden =
            alternatives.length === 0;
        }
      };

      const renderResult = () => {
        const allCandidates = candidates();

        if (!allCandidates.length) {
          root.querySelector(
            '[data-lc-tb-result-title]'
          ).textContent =
            'Für diese Größe ist derzeit keine Variante hinterlegt';

          root.querySelector(
            '[data-lc-tb-result-summary]'
          ).textContent =
            'Bitte wählen Sie eine andere Größe oder senden Sie uns eine persönliche Anfrage für eine Sonderanfertigung.';

          finder.hidden = true;
          result.hidden = false;

          result.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          return;
        }

        const primary = allCandidates[0];
        const product = primary.product;
        const variant = primary.variant;
        const copy = productCopy[product.key];

        state.product = product;
        state.variant = variant;

        root.querySelector(
          '[data-lc-tb-result-title]'
        ).textContent = product.title;

        root.querySelector(
          '[data-lc-tb-result-summary]'
        ).textContent = copy.summary;

        root.querySelector(
          '[data-lc-tb-result-variant]'
        ).textContent =
          `${variant.title} · ${product.height}`;

        root.querySelector(
          '[data-lc-tb-result-price]'
        ).textContent =
          variant.price || product.price;

        root.querySelector(
          '[data-lc-tb-result-badge]'
        ).textContent = product.badge;

        root.querySelector(
          '[data-lc-tb-product-link]'
        ).href = productUrl(primary);

        const image = root.querySelector(
          '[data-lc-tb-result-image]'
        );

        if (product.image) {
          image.src = product.image;
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
        }

        image.alt = product.imageAlt || product.title;

        const reasons = [
          goalReasons[state.goal],
          mattressReasons[state.mattress],
          climateReasons[state.climate],
          feelReasons[state.feel],
          copy.material,
          copy.structure
        ];

        if (allCandidates.length === 1) {
          reasons.push(
            `In der gewählten Größe ${sizeLabel(
              state.size
            )} ist im aktuellen Sortiment nur dieses Modell hinterlegt.`
          );
        }

        root.querySelector(
          '[data-lc-tb-reasons]'
        ).innerHTML = reasons
          .filter(Boolean)
          .map(
            (reason) =>
              `<li>${escapeHtml(reason)}</li>`
          )
          .join('');

        root.querySelector(
          '[data-lc-tb-decision-note]'
        ).innerHTML =
          `<strong>Entscheidungshilfe:</strong>` +
          `<span>${escapeHtml(copy.decision)}</span>`;

        const cartButton = root.querySelector(
          '[data-lc-tb-cart]'
        );

        cartButton.disabled = !variant.available;

        cartButton.textContent = variant.available
          ? 'In den Warenkorb'
          : 'Derzeit nicht verfügbar';

        root.querySelector(
          '[data-lc-tb-cart-status]'
        ).textContent = variant.available
          ? ''
          : 'Diese Ausführung ist momentan nicht unmittelbar lieferbar. Weitere Informationen finden Sie auf der Produktseite.';

        renderAlternatives(allCandidates);

        finder.hidden = true;
        result.hidden = false;

        result.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      };

      const advance = (reposition = true) => {
        if (state.step < steps.length - 1) {
          state.step += 1;
          renderStep(reposition);
        } else {
          renderResult();
        }
      };

      root
        .querySelectorAll('[data-lc-tb-answer]')
        .forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;

            const key = button.dataset.lcTbAnswer;

            root
              .querySelectorAll(
                `[data-lc-tb-answer="${key}"]`
              )
              .forEach((option) => {
                const selected = option === button;

                option.classList.toggle(
                  'is-selected',
                  selected
                );

                option.setAttribute(
                  'aria-pressed',
                  selected ? 'true' : 'false'
                );
              });

            state[key] = button.dataset.value;

            window.clearTimeout(autoAdvanceTimer);

            autoAdvanceTimer = window.setTimeout(
              () => advance(true),
              220
            );
          });
        });

      next.addEventListener('click', () => {
        window.clearTimeout(autoAdvanceTimer);
        advance(true);
      });

      back.addEventListener('click', () => {
        window.clearTimeout(autoAdvanceTimer);

        if (state.step > 0) {
          state.step -= 1;
          renderStep(true);
        }
      });

      edit.addEventListener('click', () => {
        window.clearTimeout(autoAdvanceTimer);

        result.hidden = true;
        finder.hidden = false;
        state.step = 0;

        renderStep();

        finder.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });

      root
        .querySelector('[data-lc-tb-cart]')
        .addEventListener('click', async (event) => {
          const button = event.currentTarget;
          const status = root.querySelector(
            '[data-lc-tb-cart-status]'
          );

          if (!state.variant || !state.variant.available) {
            return;
          }

          button.disabled = true;
          status.textContent =
            'Der Topper wird hinzugefügt …';

          try {
            const rootPath =
              window.Shopify?.routes?.root || '/';

            const response = await fetch(
              `${rootPath}cart/add.js`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: Number(state.variant.id),
                      quantity: 1
                    }
                  ]
                })
              }
            );

            if (!response.ok) {
              throw new Error('cart');
            }

            status.textContent =
              'Der Topper wurde in den Warenkorb gelegt.';

            document.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true
              })
            );

            window.setTimeout(() => {
              button.disabled = false;
              button.textContent = 'Weiteren hinzufügen';
            }, 1200);
          } catch (error) {
            status.textContent =
              'Das Hinzufügen hat nicht funktioniert. Bitte öffnen Sie die Produktseite.';

            button.disabled = false;
          }
        });

      updateSizeAvailability();
      renderStep();
    };

    const initialiseAll = () => {
      document
        .querySelectorAll('[data-lc-tb]')
        .forEach(initialise);
    };

    initialiseAll();

    document.addEventListener(
      'shopify:section:load',
      initialiseAll
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
